/*
 * @Date: 2020-09-07 09:41:02
 * @Author: lvjun
 * @Description: 路由
 */
const RouterArr = [
  // 首页
  {
    path: "index",
    name: "index",
    component: () => import("@/views/index/Index.vue"),
    meta: {
      icon: "iconcaidan-shouye",
      title: "首页",
      affix: true,
      keepAlive: true,
    },
  },
  {
    path: "personalCenter",
    name: "personalCenter",
    component: () => import("@/views/index/PersonalCenter.vue"),
    meta: {
      title: "个人中心",
      keepAlive: true,
    },
    isShow: 0,
  },
  {
    path: "customerManager",
    name: "customerManager",
    component: () =>
      import("@/views/basic-configuration/customerManager.vue"),
    meta: {
      title: "客服账号管理",
      keepAlive: true,
    },
  },
  {
    path: "customerManagerAdd",
    name: "customerManagerAdd",
    component: () =>
      import("@/views/basic-configuration/customerManagerAdd.vue"),
    meta: {
      title: "客服账号管理-新增",
      keepAlive: true,
    },
  },
  {
    path:'customerManagerNew',
    name:'customerManagerNew',
    component: () =>
      import("@/views/basic-configuration/customerManagerNew.vue"),
    meta: {
      title: "申请记录汇总",
      keepAlive: true,
    }
  },
  {
    path: "imOnline",
    name: "imOnline",
    iframeComponent: () =>
      import("@/views/online-servicer/ServicerLogin.vue"),
    meta: {
      title: "在线客服登录",
      keepAlive: true,
    },
  },
  {
    path: "onlineServicer",
    name: "onlineServicer",
    component: () =>
      import("@/views/online-servicer/onlineServicer.vue"),
    meta: {
      title: "在线客服列表",
      keepAlive: true,
    },
  },
  {
    path: "microCallBoard",
    name: "microCallBoard",
    component: () =>
      import("@/views/microCallBoard/microCallBoard.vue"),
    meta: {
      title: "微呼客服接待实况看板",
      keepAlive: true,
    },
  },
  {
    path: "callCenter",
    name: "callCenter",
    component: () => import("@/views/workorder/recordSheet.vue"),
    meta: {
      title: "热线工作台",
      keepAlive: true,
    },
  },
  {
    path: "tiktokTable",
    name: "tiktokTable",
    iframeComponent: () => import("@/views/tiktokTable/index.vue"),
    meta: {
      title: "平台在线",
      keepAlive: true,
    },
  },
  {
    path: "imService",
    name: "imService",
    iframeComponent: () => import("@/views/im-service/index.vue"),
    meta: {
      title: "在线工作台",
      keepAlive: true,
    },
  },
  {
    path: "callCenterNew",
    name: "callCenterNew",
    component: () => import("@/views/workorder/callCenterNew.vue"),
    meta: {
      title: "录单(新)",
      keepAlive: true,
    },
  },
  {
    path: "imServiceNew",
    name: "imServiceNew",
    iframeComponent: () => import("@/views/im-service-new/index.vue"),
    meta: {
      title: "飞兔在线(新)",
      keepAlive: true,
    },
  },
  {
    path: "InfoNotification",
    name: "InfoNotification",
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@/views/information-notification/InfoNotification.vue'
      ),
    meta: {
      title: "信息通知",
      keepAlive: true,
    },
  },
  {
    path:'DEEP_SEEK_HELPER',
    name:'DEEP_SEEK_HELPER',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@/views/deep-seek-helper/DeepSeekHelper.vue'
      ),
    meta: {
      title: "兔智星AI助手",
      keepAlive: true,
    },
    isShow: 0,
  }
];
export default RouterArr.map((item) => ({
  path: item.path,
  name: item.name,
  component: item.component,
  iframeComponent: item.iframeComponent,
  meta: item.meta,
}));
